<template>
  <!-- AQI对比 -->
  <div class="curveWrapper main">
    <div class="head" style="margin-bottom:0.24rem">
      <!-- 搜索区域 -->
      <div class="searchArea">
          <div class="title">查询筛选</div>
          <div class="content">
              <el-form style="width: 90%"  label-width="90px">
                  <el-row :gutter="24">
                      <el-col :span="24">
                          <el-form-item label="选择设备：">
                              <el-select v-model="quantitySelected" placeholder="请选择" size="small" @click.native="selectDevice">
                                  <el-option label="" value=""></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">
                      <el-col :span="12">
                          <el-form-item label="时间区间：">
                          <el-select v-model="searchParam.timeLxName" placeholder="请选择" size="small"
                          @change="searchChange($event,'timeLx')">
                              <el-option v-for="(item,index) in timeList"
                                   :label="item.label"
                                   :value="item.value"
                                   :key="index"></el-option>
                          </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="选择日期：">
                          <el-date-picker
                              v-model="dateRange"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              size="small"
                              :picker-options="pickerOptions"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              @change="changeDate">
                          </el-date-picker>
                          </el-form-item>
                      </el-col>
                  </el-row>
              </el-form>
              <div class="block"></div>
              <div class="rightBtn">
                  <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="searchBtnClick">查询</el-button>
                  <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;"  @click="resetting">重置</el-button>
              </div>
          </div>
      </div>
    </div>
    <!-- 图表 -->
    <section class="section">
      <div class="sectionSearch">
        <div class="title">
          <div>AQI占比 <span style="padding: 0 0.1rem;color:#ccc">|</span></div>
          <div>{{quantitySelected}}</div>
          <div v-if="isExpand" class="el-icon-caret-right" style="font-size:0.24rem" @click="isExpand = false"></div>
          <div v-if="!isExpand" class="el-icon-caret-bottom" style="font-size:0.24rem"  @click="isExpand = true"></div>
        </div>
      </div>
      <div class="expandContent" v-if="!isExpand">
           <div class="item" v-for="(item,index) in selectedRows" :key="index">
              <div class="round"></div>
              <span>{{item.name}}</span>
           </div>
      </div>

      <!-- 柱状图 -->
      <CompareBar ref="CompareBar"
                  :ajaxParam="ajaxParam"
                  :scrollTop="scrollTop" />
    </section>
  </div>
</template>

<script>
import Com from '@/common/js/com.js'
import CompareBar from '@/components/dataCompare/children/compareBar.vue'
import CompareDown from '@/components/dataCompare/children/compareDown.vue'
export default {
  props: ['paramsObject'],
  components: {
    CompareBar,
    CompareDown,
  },
  data () {
    return {
      searchParam: { /* 页面搜索项 */
        timeLx: '',
        timeLxName: '',
        start: '',
        end: '',
        code: [],
        category: [],
        Eparam: ''
      },
      timeList: [],
      ajaxParam: {}, /* 柱状图数据入参 */
      selectedRows: [], /* selectedRows: 表格选中数据 */
      scrollTop: 0,
      quantitySelected:'',
      dateRange:[], // 日期范围
      selectDeviceDialog: false,
      isExpand: true,
      pickerOptions:{  // 只能选择今天以及今天之前的日期
        disabledDate(date) {
          return date.getTime()> Date.now();
        }
      }
    }
  },
  created () {
    const menu2Search = window.sessionStorage.getItem('menu2Search')
    if (menu2Search) {
      const menu2SearchObj = JSON.parse(menu2Search)
      // console.log(menu2SearchObj, '---------------->AQI缓存')
      this.timeList = Com.timeList
      this.searchParam.timeLx = menu2SearchObj.timeLx
      this.searchParam.timeLxName = menu2SearchObj.timeLxName
      this.searchParam.start = menu2SearchObj.start
      this.searchParam.end = menu2SearchObj.end
      this.searchParam.Eparam = menu2SearchObj.Eparam
      this.dateRange.push(menu2SearchObj.start)
      this.dateRange.push(menu2SearchObj.end)
    } else {
      this.timeList = Com.timeList
      this.searchParam.timeLx = Com.timeDefault
      this.searchParam.timeLxName = Com.timeDefaultName
      var start = Com.getBeforeDate(7, 'date')
      var end = Com.getBeforeDate(0, 'date')
      this.searchParam.start = start
      this.searchParam.end = end
      this.dateRange.push(start)
      this.dateRange.push(end)
    }
  },
  mounted () {
    document.getElementById('bodyWrapperId').addEventListener('scroll', () => {
      const top = document.getElementById('bodyWrapperId').scrollTop
      this.scrollTop = top
    })
  },
  methods: {
    selectDevice() { // 选择设备
      this.$emit('isShow',true)
    },
    // 切换日期范围
    changeDate(dateString) {
      const num = this.dateDiff(dateString[0], dateString[1])
      if(num > 366) {
        this.$message.warning('最多只可以选择一年！')
      } else {
        this.searchParam.start = dateString[0]
        this.searchParam.end = dateString[1]
      }
    },
    onChangeDate(date, dateString) { // 日均值日期选择
      this.searchParam.start = dateString[0]
      this.searchParam.end = dateString[1]
    },
    downClickPar(val, type, code, gkz) { // 下拉选择
      if (val === '时均值') {
        this.searchParam.timeLxName = val
        this.searchParam[type] = 'H'
      } else if (val === '日均值') {
        this.searchParam.timeLxName = val
        this.searchParam[type] = 'D'
      } else {
        this.searchParam[type] = val
      }
    },
    // 查询事件
    searchBtnClick() {
      if (this.searchParam.timeLx === 'D') {
        const num = Com.dateDiff(this.searchParam.start, this.searchParam.end)
        if (num < 2) {
          this.$message.warning('时间类型为天时,请间隔2天以上')
        } else {
          this.searchUrlClick()
        }
      } else {
        this.searchUrlClick()
      }
    },
    searchUrlClick() {
      this.ajaxParam = {
        timeLx: this.searchParam.timeLx,
        timeLxName: this.searchParam.timeLxName,
        start: this.searchParam.start,
        end: this.searchParam.end,
        code: this.searchParam.code,
        category: this.searchParam.category,
        Eparam: this.searchParam.Eparam
      }

      // 修改时间格式
      const idx = this.ajaxParam.start.indexOf(' ')
      if (idx !== -1) { // 年月日时分秒
        if (this.ajaxParam.timeLx === 'D') {
          this.ajaxParam.start = (this.ajaxParam.start).substring(0, idx)
          this.ajaxParam.end = (this.ajaxParam.end).substring(0, idx)
        }
      } else { // 年月日
        if (this.ajaxParam.timeLx === 'H') {
          const time = Com.stringTime((new Date()), 'time')
          this.ajaxParam.start = (this.ajaxParam.start) + time
          this.ajaxParam.end = (this.ajaxParam.end) + time
        }
      }

      // 过滤数据
      if (this.selectedRows.length > 0) {
        const code = []
        const category = []
        this.selectedRows.forEach((item, i) => {
          code.push(item.code)
          category.push(item.name)
        })
        this.ajaxParam.code = code.join(',')
        this.ajaxParam.category = code
      }
      if (this.$store.state.moduleSD.Eparam) {
        this.ajaxParam.Eparam = this.$store.state.moduleSD.Eparam
      }
      window.sessionStorage.setItem('menu2Search', JSON.stringify(this.ajaxParam))
      // console.log(JSON.stringify(this.ajaxParam), '----------menu2Search查询')
      this.$refs.CompareBar.initChart(this.ajaxParam, this.scrollTop)
    },
     // 重置搜索框
    resetting() {
      this.searchParam.timeLx = 'H'
      this.searchParam.timeLxName = '时均值'
      this.searchBtnClick()
    },
  },
  watch: {
    paramsObject: {
      handler: function (value) {
        this.quantitySelected = '已选择'+ value.length + '台设备'
        const result = JSON.parse(JSON.stringify(value))
        this.selectedRows = result
        this.searchBtnClick() // 查询
      },
      deep: true
    }
  },
}
</script>

<style lang="less" scoped>
.curveWrapper {
  height: calc(100% - 0.64rem);
  display: flex;
  flex-direction: column;
}
.section {
  padding: 0.24rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  .sectionSearch {
    display: flex;
    .title {
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      color:#405891;
      font-weight: bold;
    }
  }
}
.timeGroup > span {
  font-size: 0.14rem;
  color: rgba(0, 0, 0, 0.65);
  padding: 0 0.1rem;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-form-item {
  margin-bottom: 0.1rem;
  .el-form-item__label {
      color: #405891;
  }
}
::v-deep .el-range-editor--small.el-input__inner {
  width: 100%;
}
.expandContent {
  color: #405891;
  padding: 0 0.24rem 0.24rem 0.24rem;
  margin-bottom: 0.1rem;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #cccc;
  .item {
    margin-right: 0.25rem;
    margin-bottom: 0.1rem;
    .round {
      width: 10px;
      height: 10px;
      border: 2px solid #437EDE;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
